import axios from '~/axios';
import mapValues from 'lodash/mapValues';
import {prepareModel} from "~/data/dataPreparer";
import { default as  defaultAuthenticatedRequest} from "~/backend/authenticatedRequest";

export default async function fetchModelConfigs(baseUrl, modelNames = [], authenticatedRequest = defaultAuthenticatedRequest) {
    let modelConfigUrl = `${baseUrl}/modelconfigs`;
    if(modelNames.length) {
        modelConfigUrl += `?configNames=${modelNames.join(',')}`;
    }

    let models = await authenticatedRequest(async () => {
        let axData = await axios.get(modelConfigUrl);
        return axData.data;
    });

    // await timeout(2000);

    return mapValues(models, (model) => prepareModel(model));
}